// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"229":"98cacb622d6055c6","603":"d9365ded1dae3bcc","888":"779a2ac1f69fe9f3"}[chunkId] + ".css";
};